// AI Generated Test
import { Injectable } from '@angular/core';
import { SourceCodeExcludeRepoService } from '@client/app/services/api/source-code-exclude-repo/source-code-exclude-repo.service';

@Injectable({
    providedIn: 'root',
})
export class SourceCodeExcludesEntityService {

    constructor (
        private sourceCodeExcludeRepoService: SourceCodeExcludeRepoService,
    ) { }

    update (sourceCodeExclude: any, updatedSourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.sourceCodeExcludeRepoService.update(sourceCodeExclude, updatedSourceCodeExclude, params);
    }

    create (sourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.sourceCodeExcludeRepoService.create(sourceCodeExclude, params);
    }

    destroy (sourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.sourceCodeExcludeRepoService.destroy(sourceCodeExclude.id, params);
    }
}
